import { Navigate } from "react-router-dom";
import { Show } from "@clerk/react";
import { useRole } from "@/contexts/RoleContext";

function RoleGate({ children, admin }) {
  const { isAdmin, actingAsAdmin } = useRole();
  if (isAdmin === null) return null;
  if (admin && !isAdmin) return <Navigate to="/dashboard" replace />;
  if (!admin && actingAsAdmin) return <Navigate to="/admin" replace />;
  return children;
}

export function ClientRoute({ children }) {
  return (
    <>
      <Show when="signed-in"><RoleGate>{children}</RoleGate></Show>
      <Show when="signed-out"><Navigate to="/sign-in" replace /></Show>
    </>
  );
}

export function AdminRoute({ children }) {
  return (
    <>
      <Show when="signed-in"><RoleGate admin>{children}</RoleGate></Show>
      <Show when="signed-out"><Navigate to="/sign-in" replace /></Show>
    </>
  );
}
